import '../../css/base.css';

const ContactUs = () => {

  return (
    <div>
      <h2 className="your-stay-section-heading">Caretaker / Cleaner</h2>
      <p className="your-stay-text">In the event that there is a problem with the cottage that can be dealt with
                                    remotely please contact either your booking agent in the first instance, if
                                    it is something the owners may need to assist with please contact us using the details at the bottom of the page.
      </p>                                            
      <p className="your-stay-text">Tracey is our cleaner and caretaker. If the matter needs on site attention please contact Tracey on
                                    07467 800730 
                                    or by email tracey.sandaig@gmail.com. 
      </p>                                            
      <p className="your-stay-text"><strong>Please keep in mind that Tracey lives in Corran
                                            so please only contact her if the matter is urgent.</strong> 
      </p>                                            
    </div>
  );
}

export default ContactUs
